import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation} from 'swiper/core'
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation])
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
